import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import HelpIcon from "@mui/icons-material/Help";
import { FormControl, FormLabel, Grid2 } from "@mui/material";
import FileUpload from "../FileUpload/FileUpload";
import { useDispatch, useSelector } from "react-redux";
import { useFetchUser } from "../../methods/auth/auth";
import { callBackendApi } from "../../methods/axiosInstances/backendInstance/apiRequest";
import { showSnackbar } from "../../store/snackbarSlice/snackbarSlice";

const TicketComponent = ({ children }) => {
  const fetchUser = useFetchUser();
  const dispatch = useDispatch();
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [errors, setErrors] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    attachment: null,
  });
  const [upload, setUpload] = useState(null);

  const auth = useSelector((state) => state.user);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    const formDataRequest = new FormData();
    formDataRequest.append("title", formData.title);
    formDataRequest.append("description", formData.description);
  
    // Append the image file if it exists
    if (upload && upload[0]) {
        formDataRequest.append("attachment", upload[0]);
    }

    const response = await callBackendApi("/tickets", "POST", formDataRequest);
    if (response && response.success) {
      setIsFormOpen(false);
      dispatch(showSnackbar({ message: "Request submitted successfully!" }));
    } else {
      dispatch(
        showSnackbar({
          message:
            "Something happened with your request! Please try again or contact support",
        })
      );
      if (response?.error) {
        setErrors(response.error);
      }
    }
  };

  useEffect(() => {
    const checkAuth = async () => {
      await fetchUser();
    };
    checkAuth();
  }, []);

  if (!auth.user) {
    return;
  }

  return (
    <div>
      <div
        variant="contained"
        color="primary"
        style={{
          position: "fixed",
          bottom: 50,
          right: 50,
          borderRadius: 50,
          width: 50,
          height: 50,
          cursor: "pointer",
        }}
        onClick={() => setIsFormOpen(!isFormOpen)}
      >
        {isFormOpen ? (
          <HelpIcon fontSize="large" />
        ) : (
          <HelpIcon fontSize="large" />
        )}
      </div>

      {isFormOpen && (
        <Card
          sx={{
            position: "fixed",
            bottom: 110,
            right: 50,
            width: 300,
            boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
          }}
        >
          <CardContent>
            <Grid2>
              <Grid2 sx={12}>
                <FormControl fullWidth>
                  <FormLabel htmlFor="title">Title</FormLabel>
                  <TextField
                    name="title"
                    required
                    fullWidth
                    id="title"
                    placeholder="Title"
                    value={formData.title}
                    onChange={handleInputChange}
                    helperText={errors?.title?.[0] || null}
                    color={errors?.title?.[0] ? "error" : "primary"}
                  />
                </FormControl>
              </Grid2>
              <Grid2 sx={12} className="my-1">
                <FormControl fullWidth>
                  <FormLabel htmlFor="description">Description</FormLabel>
                  <TextField
                    name="description"
                    required
                    fullWidth
                    id="description"
                    placeholder="Description"
                    multiline
                    value={formData.description}
                    onChange={handleInputChange}
                    helperText={errors?.description?.[0] || null}
                    color={errors?.description?.[0] ? "error" : "primary"}
                  />
                </FormControl>
              </Grid2>
              <Grid2 sx={12}>
                <FormControl fullWidth>
                  <FileUpload upload={upload} setUpload={setUpload} />
                </FormControl>
              </Grid2>
              <Grid2>
                <FormControl fullWidth>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    style={{ marginTop: 16 }}
                  >
                    Submit
                  </Button>
                </FormControl>
              </Grid2>
            </Grid2>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
export default TicketComponent;
